.tag {
  display: flex;
  flex: 3.5;
  flex-direction: row;
  margin-right: 1rem;
}

.outerAR {
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  padding: 0.2rem 0.45rem;
  margin-left: 1rem;
  background-color: #e4f6f0;
}

.outerZC {
  composes: outerAR;
  background-color: #e8eef7;
}

.tagAR {
  display: flex;
  background-color: #35a37e;
  padding: 0.1rem 0.35rem;
  border-radius: 0.3rem;
  margin-right: 0.4rem;
}

.tagZC {
  composes: tagAR;
  background-color: #5181c2;
}
